import React from 'react'

export const AccessDenied = () => (
  <h1 className="text-info">Access Denied!
    <span role="img" aria-label="Denied">⛔️</span>
  </h1>
);

